module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "authbio"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "top15"
  }, [_c('p', {
    staticClass: "textfirst"
  }, [_c('strong', [_vm._v("About The Author")])])]), _vm._v(" "), _c('p', [_vm._v("Kenny Francis is a 15-year entertainment industry veteran who worked his way up from an ambitious intern at Polygram Records, to owning and operating the hip-hop industry’s most\n  sought-after video vixen agency, Dimepiece USA. After furnishing countless models for the music videos of super star artists like Usher, Eminem, 50 Cent, Kanye West, Nelly and many others, Francis\n  continued his meteoric rise with his Playboy TV show, "), _c('em', [_vm._v("Buckwild")]), _vm._v(", which he created and produced alongside rap luminary Snoop Dogg. Originally from Brooklyn, N.Y., he has been living in Sothern\n  California for the past twenty years.")]), _vm._v(" "), _c('div', {
    staticClass: "figure1"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "303",
      "src": "html/docimages/img1.jpg",
      "width": "141"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-458db70a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/02_aauthbio.vue
// module id = 63
// module chunks = 0